import React from 'react';

import { ConstructorHeaderKeys, DominantEnum, OneConstructorFieldType } from '../schema';

export type UpdateHeaderPayloadType = {
  key: ConstructorHeaderKeys;
} & (
  | {
      checked: true;
      customFieldId?: number;
      data: OneConstructorFieldType;
    }
  | {
      checked?: false;
    }
);

export type ConstructorMethodsType = {
  setFilter: (value: boolean) => void;
  setTrash: (value: ConstructorContextType['trash']) => void;
  setUpload: (value: ConstructorContextType['upload']) => void;
  editUpload: (value: Partial<ConstructorContextType['upload']>) => void;
  setCreateOrUpdate: (value: ConstructorContextType['createOrUpdate']) => void;
  setCreateOrUpdateFilter: ({ key, checked }: { key: `${string}Filter`; checked: boolean }) => void;
  setCreateOrUpdateHeader: (payload: UpdateHeaderPayloadType) => void;
  setCreateOrUpdateHeaders: (
    checked: boolean,
    payload: {
      checked: boolean;
      key: ConstructorHeaderKeys;
      data?: OneConstructorFieldType;
      headerKey: `${string}${'Header'}`;
    }[]
  ) => void;
  setCreateOrUpdateAllHeaders: (headers: ConstructorHeaderType[]) => void;
  setCreateOrUpdateHeaderName: ({ index, name }: { index: number; name?: string }) => void;
  setCreateOrUpdateErrors: (errors: ConstructorContextType['createOrUpdate']['errors']) => void;
};

export type ConstructorHeaderType = OneConstructorFieldType & { key: ConstructorHeaderKeys };

export type ConstructorContextType = {
  trash: {
    id?: number;
    visible: boolean;
  };

  upload: {
    id?: number;
    name?: string;
    count?: number;
    visible: boolean;
    page?: number;
    filters?: Record<string, any>;
  };

  createOrUpdate: {
    id?: number;
    comment?: string;
    visible: boolean;
    dominant: DominantEnum;
    filters?: `${string}Filter`[];
    headers?: ConstructorHeaderType[];
    errors?: {
      comment: boolean;
      filter: `${string}Filter`[];
    };
  };

  filter: boolean;

  methods: ConstructorMethodsType;
};

const emptyFn = () => {};

const Context = React.createContext<ConstructorContextType>({
  filter: false,

  trash: {
    visible: false
  },

  upload: {
    visible: true
  },

  createOrUpdate: {
    visible: false,
    dominant: DominantEnum.CONTRACT
  },

  methods: {
    setFilter: emptyFn,
    setTrash: emptyFn,
    setUpload: emptyFn,
    editUpload: emptyFn,
    setCreateOrUpdate: emptyFn,
    setCreateOrUpdateFilter: emptyFn,
    setCreateOrUpdateHeader: emptyFn,
    setCreateOrUpdateHeaders: emptyFn,
    setCreateOrUpdateAllHeaders: emptyFn,
    setCreateOrUpdateHeaderName: emptyFn,
    setCreateOrUpdateErrors: emptyFn
  }
});

export default Context;
